import axios from "axios";

export function setUserData(user) {
    return (dispatch) => dispatch({ type: "USER_DATA", payload: user });
}

export function setAuthToken(loginToken) {
    return (dispatch) => dispatch({ type: "LOGIN_SUCCESS", loginToken });
}

/*
export function loginRequest(username, password) {
  return function(dispatch) {
    axios.post('/v1/auth/', {
      username,
      password
    })
    .then((response) => {
      console.info({data: response.data});
      if (response.data.token) {
        localStorage.userEmail = response.data.user.email;
        localStorage.userUUID = response.data.user.uuid;
        localStorage.loginToken = response.data.token;
        localStorage.userName = response.data.user.full_name;
        localStorage.userRoles = JSON.stringify(response.data.user.roles);
        localStorage.userPermissions = JSON.stringify(response.data.user.permissions);

        // set the defaults because checkAuth is not triggered when a browserHistory.push() is done. This way the bearer acutally is set for axios
        axios.defaults.headers.Authorization = 'Token ' + response.data.token;



        if (response.data.user.is_blocked) {
          dispatch({
            type: 'LOGIN_ERROR',
            loginToken: 'blocked',
            message: 'Oeps! Je account lijkt geblokkeerd. Neem contact op met NIBHV: 010-2892888'
          });
        }
        else if (response.data.user.roles.length === 1 && response.data.user.roles.includes('student')) {
          dispatch({
            type: 'LOGIN_ERROR',
            loginToken: 'invalid',
            message: 'Je hebt geen toegang tot NIBHV Portaal'
          });
        }
        else if (response.data.user.roles.length === 2 && response.data.user.roles.includes('student') && response.data.user.roles.includes('instructor')) {
          dispatch({
            type: 'LOGIN_ERROR',
            loginToken: 'invalid',
            message: 'Je hebt geen toegang tot NIBHV Portaal'
          });
        }
        else {
          dispatch({
            type: 'LOGIN_SUCCESS',
            loginToken: response.data.token
          });

          if (localStorage.currentLocation) {
            // let newLoc = localStorage.currentLocation;
            localStorage.removeItem('currentLocation');
            // window.location = newLoc;
          }
          // else {
          browserHistory.push('/courses');
          // }
        }
      }
      else {
        dispatch({
          type: 'LOGIN_ERROR',
          loginToken: 'invalid',
          message: response.data.non_field_errors[0]
        });
      }
    })
    .catch(function(err) {
      localStorage.loginToken = 'invalid';
      if (err && err.response && err.response.data && err.response.data.non_field_errors && err.response.data.non_field_errors[0]) {
        dispatch({
          type: 'LOGIN_ERROR',
          loginToken: 'invalid',
          message: err.response.data.non_field_errors[0]
        });
      }
      else {
        dispatch({
          type: 'LOGIN_ERROR',
          loginToken: 'invalid',
          message: false
        });
      }
    });
  };
}
*/

export function logout(error = null) {
    return (dispatch) => {
        // Clear the state
        dispatch({ type: "LOGOUT", error });
        // Clear the local storage
        // localStorage.clear(); // needed?
    };
}

export function logoutRequest() {
    return function (dispatch) {
        axios.get("/v1/auth/logout/").then(() => (window.location = "/"));

        // is this really needed? Doesn't dispatching logout do enough?
        localStorage.clear();

        dispatch({
            type: "LOGOUT"
            // loginToken: '',
            // message: 'U bent succesvol uitgelogd'
        });
    };
}
